/* GOS cart core v1: pickup store choice by size_availability (spec 2026-10-29, owner decision 5). No DOM. */
(function (w) {
  var STORES = [{ id: 'ЦУМ', key: 'ЦУМ' }, { id: 'Москва', key: 'Москва' }, { id: 'Аружан', key: 'Астана Аружан' }];

  // SKU is {article}-{size}; an article may itself contain a dash (202636-1), so split at the last one.
  function parseLine(item) {
    var sku = String(item.sku || ''), i = sku.lastIndexOf('-');
    var article = i > 0 ? sku.slice(0, i) : String(item.vendor || '');
    var size = i > 0 ? sku.slice(i + 1) : String(item.variant_title || '');
    return { article: article, size: size, qty: Number(item.quantity) || 0, title: String(item.product_title || '') };
  }

  // Stores where every pair of the cart is in stock in the needed quantity.
  function storesWithAll(lines, rows) {
    if (!lines.length) return [];
    var need = {}, have = {};
    lines.forEach(function (l) { var k = l.article + '|' + l.size; need[k] = (need[k] || 0) + l.qty; });
    (rows || []).forEach(function (r) { have[r.article + '|' + r.size] = r.store_availability || {}; });
    return STORES.filter(function (s) {
      return Object.keys(need).every(function (k) { return Number((have[k] || {})[s.key] || 0) >= need[k]; });
    }).map(function (s) { return s.id; });
  }

  var T = {
    ru: { hello: 'Здравствуйте! Хочу оформить заказ с сайта:', article: 'Артикул', size: 'размер', qty: 'шт', store: 'Магазин самовывоза' },
    kk: { hello: 'Сәлеметсіз бе! Сайттан тапсырыс бергім келеді:', article: 'Артикул', size: 'өлшем', qty: 'дана', store: 'Алып кету дүкені' }
  };
  function managerText(lines, storeId, lang) {
    var t = T[lang] || T.ru, out = [t.hello, ''];
    lines.forEach(function (l) { out.push('• ' + l.title + ' — ' + t.article + ' ' + l.article + ', ' + t.size + ' ' + l.size + ', ' + l.qty + ' ' + t.qty); });
    if (storeId) out.push('', t.store + ': ' + storeId);
    return out.join('\n');
  }

  w.GosCartCore = { STORES: STORES, parseLine: parseLine, storesWithAll: storesWithAll, managerText: managerText };
})(window);

/* GOS cart UI v1: product page manager button, cart page pickup store. Needs window.GOS_CART from snippet gos-cart-v1. */
(function (w, d) {
  var C = w.GOS_CART, core = w.GosCartCore;
  if (!C || !core) return;
  var S = C.s;

  function waHref(text) { return 'https://wa.me/' + C.wa + '?text=' + encodeURIComponent(text); }
  function el(tag, cls, text) { var e = d.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }

  /* Product page: equal «Написать менеджеру» button and the manager line right under «В корзину». */
  function productPage() {
    var buttons = d.querySelector('.product-form__buttons');
    if (!buttons || buttons.parentNode.querySelector('.gos-cart-wa')) return;
    var meta = (w.ShopifyAnalytics && w.ShopifyAnalytics.meta && w.ShopifyAnalytics.meta.product) || null;
    var a = el('a', 'button button--full-width button--primary gos-cart-wa', S.write_manager);
    a.target = '_blank'; a.rel = 'noopener';
    function update() {
      var idInput = d.querySelector('form[action*="/cart/add"] input[name="id"]'), v = null;
      if (meta && idInput) for (var i = 0; i < meta.variants.length; i++) if (String(meta.variants[i].id) === String(idInput.value)) v = meta.variants[i];
      var line = core.parseLine({ sku: v ? v.sku : '', vendor: meta ? meta.vendor : '', variant_title: v ? v.public_title : '', quantity: 1, product_title: (meta && v && v.name) ? v.name.split(' - ')[0] : d.title });
      a.href = waHref(core.managerText([line], null, C.lang) + '\n\n' + w.location.href);
    }
    update();
    d.addEventListener('change', update);
    a.addEventListener('mousedown', update); a.addEventListener('touchstart', update, { passive: true });
    buttons.parentNode.insertBefore(el('p', 'gos-cart-note', S.manager_confirms), buttons.nextSibling);
    buttons.parentNode.insertBefore(a, buttons.nextSibling);
  }

  /* Cart page: stores where every pair is in stock (size_availability), choice saved as cart attribute gos_pickup_store. */
  var box, lines = [], chosen = '';
  function save(store) {
    chosen = store;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { gos_pickup_store: store } }) })
      .catch(function () {});
  }
  function availability(ls) {
    var arts = {}; ls.forEach(function (l) { arts['"' + l.article.replace(/"/g, '') + '"'] = 1; });
    var url = C.sb.url + '/rest/v1/size_availability?select=article,size,store_availability&article=in.(' + encodeURIComponent(Object.keys(arts).join(',')) + ')';
    return fetch(url, { headers: { apikey: C.sb.key } }).then(function (r) { if (!r.ok) throw Error(r.status); return r.json(); });
  }
  function renderStores(ok) {
    var list = box.querySelector('[data-gos-stores]'); list.textContent = '';
    if (chosen && ok.indexOf(chosen) < 0) save('');
    core.STORES.forEach(function (s) {
      var has = ok.indexOf(s.id) >= 0, lab = el('label', 'gos-cart-store' + (has ? '' : ' is-off'));
      var r = el('input'); r.type = 'radio'; r.name = 'gos_pickup_store'; r.value = s.id; r.disabled = !has; r.checked = has && chosen === s.id;
      r.addEventListener('change', function () { save(s.id).then(updateWa); updateWa(); });
      lab.appendChild(r); lab.appendChild(el('span', 'gos-cart-store__name', s.id)); lab.appendChild(el('span', 'gos-cart-store__status', has ? S.all_in_stock : S.some_missing));
      list.appendChild(lab);
    });
  }
  function updateWa() { var a = box.querySelector('[data-gos-wa]'); if (a) a.href = waHref(core.managerText(lines, chosen || null, C.lang)); }
  function relabelCheckout() { if (C.lang !== 'kk') return; var b = d.querySelectorAll('button[name="checkout"]'); for (var i = 0; i < b.length; i++) b[i].textContent = S.checkout; }
  function refresh() {
    relabelCheckout();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      box.hidden = !cart.item_count;
      chosen = (cart.attributes && cart.attributes.gos_pickup_store) || '';
      lines = cart.items.map(core.parseLine);
      updateWa();
      if (!lines.length) return;
      return availability(lines).then(function (rows) { renderStores(core.storesWithAll(lines, rows)); })
        .catch(function () { box.querySelector('[data-gos-stores]').textContent = ''; });
    }).catch(function () {});
  }
  function cartPage() {
    box = d.getElementById('gos-cart-pickup');
    if (!box) return;
    refresh();
    // Dawn declares subscribe/PUB_SUB_EVENTS as top-level script bindings, not window properties: use bare names.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 0); });
  }

  function start() { productPage(); cartPage(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
